// Utilidades compartidas de las páginas del portal.
window.tereket = {
	// Llama a un método whitelisted. Resuelve con message; rechaza con {mensaje, campo}.
	async llamar(metodo, datos) {
		// FormData (subida de archivos) se envía tal cual; el resto como formulario codificado.
		const cuerpo = datos instanceof FormData ? datos : new URLSearchParams(datos || {});
		let respuesta;
		try {
			respuesta = await fetch("/api/method/" + metodo, {
				method: "POST",
				headers: { "X-Frappe-CSRF-Token": window.frappe && frappe.csrf_token },
				body: cuerpo,
				credentials: "same-origin",
			});
		} catch (e) {
			throw { mensaje: "No hay conexión con el servidor. Inténtalo de nuevo.", campo: null };
		}
		let json = {};
		try { json = await respuesta.json(); } catch (e) { /* respuesta no JSON */ }
		if (respuesta.ok) return json.message;
		let mensaje = "Ha ocurrido un error. Inténtalo de nuevo.", campo = null;
		try {
			const msgs = JSON.parse(json._server_messages || "[]");
			if (msgs.length) {
				const m = JSON.parse(msgs[0]);
				mensaje = (m.message || mensaje).replace(/<[^>]+>/g, "");
				campo = m.title || null;
			}
		} catch (e) { /* sin mensajes del servidor */ }
		if (respuesta.status === 429) mensaje = "Demasiados intentos. Espera un rato antes de volver a probar.";
		throw { mensaje, campo };
	},

	// Consulta (GET) a un método whitelisted. Resuelve con message; rechaza con {mensaje, estado}.
	async consultar(metodo, datos) {
		const parametros = new URLSearchParams(datos || {}).toString();
		let respuesta;
		try {
			respuesta = await fetch("/api/method/" + metodo + (parametros ? "?" + parametros : ""), {
				credentials: "same-origin",
				cache: "no-store",
			});
		} catch (e) {
			throw { mensaje: "No hay conexión con el servidor.", estado: 0 };
		}
		let json = {};
		try { json = await respuesta.json(); } catch (e) { /* respuesta no JSON */ }
		if (respuesta.ok) return json.message;
		throw { mensaje: "Ha ocurrido un error.", estado: respuesta.status };
	},

	// Muestra/limpia el error de un campo (busca #error-<nombre>).
	errorCampo(nombre, mensaje) {
		const caja = document.getElementById("error-" + nombre);
		const campo = document.getElementById(nombre);
		if (caja) caja.textContent = mensaje || "";
		if (campo) campo.classList.toggle("is-invalid", !!mensaje);
	},

	// Reglas de contraseña (las mismas que valida el servidor en validar_password).
	reglasPassword: {
		longitud: (p) => p.length >= 8,
		mayuscula: (p) => /[A-ZÁÉÍÓÚÑÜ]/.test(p),
		numero: (p) => /\d/.test(p),
	},

	// Marca en verde los requisitos cumplidos de la lista (li[data-req]) según el valor del campo.
	pintarRequisitos(campo, lista) {
		const p = campo.value;
		lista.querySelectorAll("li").forEach((li) => {
			li.classList.toggle("cumplido", tereket.reglasPassword[li.dataset.req](p));
		});
	},
};
